import { DataTable } from "carbon-components-react";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { useDonations } from "../../utils/donations";

const {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableHeader,
} = DataTable;

const headers = [
  {
    header: "Team",
    key: "selected_team",
  },
  {
    header: "Donations",
    key: "formatted_amount",
  },
];

const LeaderboardTable = ({ maxResults, overflowY = "scroll" }) => {
  const donations = useDonations(maxResults, 10000);

  const rows = useMemo(() => {
    return donations.map((item) => {
      const amount = Math.round(item.original_amount)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      item.formatted_amount = "$" + amount;
      return item;
    });
  }, [donations]);

  return (
    <div className="leaderboard-page form-page" style={{ overflowY }}>
      <DataTable
        rows={rows}
        headers={headers}
        disabled={true}
        render={({ rows, headers, getHeaderProps }) => (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>{cell.value}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      />
    </div>
  );
};

LeaderboardTable.propTypes = {
  maxResults: PropTypes.number,
  overflowY: PropTypes.string,
};

export default LeaderboardTable;
